Registrable = require 'mixins/registrable'

App.SmMiniPopupContainerComponent = Em.Component.extend Registrable,
  classNames: [ 'sm-mini-popup-container' ]
  classNameBindings: [ 'isPopupOpen:-popup-open' ]

  currentPopup: null
  isPopupOpen: Em.computed.bool('currentPopup')

  handleClick: ((event) ->
    target = Em.$(event.target)
    if target.is(@$())
      @send('closePopup')
    false
  ).on('click')

  isPopupOpenChanged: (->
    selector = @get('attachClassTo')
    return unless selector

    if @get('isPopupOpen')
      @$().closest(selector).addClass('mini-popup-opened')
    else
      @$().closest(selector).removeClass('mini-popup-opened')
  ).observes('isPopupOpen')

  actions:
    openPopup: (popupName) ->
      @set('currentPopup', popupName)
      false

    closePopup: ->
      @set('currentPopup', null)
      false
